// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domino-app > .information-space {
  margin-left: auto;
}

.button-kotobot-svg:hover {
  transform: scale(1.05);
  transition-duration: 200ms;
}

.kotobot-svg {
  margin-top: 6px;
  margin-bottom: 5vh;
}

.character-name {
  background-color: #f6f6f6;
  height: auto;
  margin-bottom: 20px;
  width: 220px;
}

.character {
  margin-bottom: 30px;
  position: relative;
  height: auto;
}

.play-rules {
  position: relative;
  padding: 12px;
  background-color: #20677b;

  border-radius: 15px;
  border-width: 1px;
  border-color: #20677b;
  border-style: solid;

  box-shadow: 5px 5px 10px #b5b5b5;

  font-size: 20px;
  font-family: "Manrope";
  color: white;
  margin: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Domino/styles/InformationSpace.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;EAEzB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;;EAEnB,gCAAgC;;EAEhC,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd","sourcesContent":[".domino-app > .information-space {\n  margin-left: auto;\n}\n\n.button-kotobot-svg:hover {\n  transform: scale(1.05);\n  transition-duration: 200ms;\n}\n\n.kotobot-svg {\n  margin-top: 6px;\n  margin-bottom: 5vh;\n}\n\n.character-name {\n  background-color: #f6f6f6;\n  height: auto;\n  margin-bottom: 20px;\n  width: 220px;\n}\n\n.character {\n  margin-bottom: 30px;\n  position: relative;\n  height: auto;\n}\n\n.play-rules {\n  position: relative;\n  padding: 12px;\n  background-color: #20677b;\n\n  border-radius: 15px;\n  border-width: 1px;\n  border-color: #20677b;\n  border-style: solid;\n\n  box-shadow: 5px 5px 10px #b5b5b5;\n\n  font-size: 20px;\n  font-family: \"Manrope\";\n  color: white;\n  margin: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
